import React, { useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { AuthContext } from "../../contexts/AuthProvider";

const PrivateRoute = ({children}) => {
    const {user, loading} = useContext(AuthContext);
    // console.log("private: ", user);
    const location = useLocation();

    if(loading){
        return  <h1>Loading</h1>;
    }

    if(!user){
        return <Navigate to="/login" state={{from: location}} replace></Navigate>
    }
    // console.log("private then: ", user, location);
    if(user){
        return children;
    }
    
};
export default PrivateRoute;